export const buildUrl = slug => {
  let url = '/';

  if (slug) {
    url += `${slug !== '/' ? `${slug.replace(/^\/|\/$/g, '')}/` : ''}`;
  }

  return url;
};
